import React from "react";
import { Table } from "@sscs/ui";
import { REPORT_PAGES_ROUTES } from "../../../constants";
import { sourceFiltered } from "../../../store/filesDiffSlice";
import { LinkToReportTab } from "../../common";
import { useReportDispatch } from "../../hooks";
import ChangeExplanation from "../ChangeExplanation";
import { CHANGE_TYPE_TO_UI_TEXT } from "../constants";
import styles from "./reproCheck.module.scss";
import { getChangeFileName } from "./utils";
const CheckDetails = ({ change }) => {
    const dispatch = useReportDispatch();
    const fileName = getChangeFileName(change);
    return (React.createElement(Table.Row, null,
        React.createElement(Table.Cell, null, CHANGE_TYPE_TO_UI_TEXT[change.changed_object]),
        React.createElement(Table.Cell, null,
            React.createElement(ChangeExplanation, { diffObjectType: change.changed_object, change: change.diff_change }),
            React.createElement("p", { className: styles.path },
                "Path: ",
                change.origin.file_path)),
        React.createElement(Table.Cell, { align: "right" },
            React.createElement(LinkToReportTab, { id: "view-file", to: `${REPORT_PAGES_ROUTES.REPRODUCIBILITY_ROUTE}/${REPORT_PAGES_ROUTES.REPRODUCIBILITY_MODIFIED_FILES}`, color: "link", onClick: () => {
                    dispatch(sourceFiltered({
                        name: fileName,
                        id: change.origin.file_id,
                    }));
                }, className: styles["view-file"] }, "View file"))));
};
export default CheckDetails;
//# sourceMappingURL=CheckDetails.js.map